import { Box, NumberInput, NumberInputField, Td, Tr } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { NewProduct } from "models/new_product_type";
import { OrderCategory } from "models/order_category";
import { OrderItemProduct } from "models/order_item_product";
import { OptionType } from "models/select_mode";
import { useRef, useState } from "react";
import formatNumber from "../hooks/formatNumber";

interface IAddItemRow {
     categ: OrderCategory
    produtos: NewProduct[];
    unidades: ClientClassificationType[];
    showError: (title: string, msg: string) => void;
    addRowItem: (item: OrderItemProduct, categ: OrderCategory) => void;
  }
  
  const AddItemRow = ({
    produtos,
    unidades,
    showError,
    addRowItem,
    categ
  }: IAddItemRow) => {
    const [selectedProduto, setSelectedProduto] = useState<NewProduct>(null);
    const [selectedUnidade, setSelectedUnidade] =
      useState<ClientClassificationType>(null);
    const [ipi, setIpi] = useState(0);
    const [qtd, setQtd] = useState(0);
    const [total, setTotal] = useState(0);
    const produtoRef = useRef(null);
  
    const calculaTotal = () => {
      const calc = selectedProduto?.precoVenda * qtd;
      const itemTotal = (calc * ipi) / 100 + calc;
      setTotal(itemTotal);
    };
  
    const onChangeProduto = (value: string) => {
      const selected = produtos.find((p) => p.id === value);
      if (selected) {
        const un = unidades?.find((u) => selected?.unidadeMedidaId === u.id);
        setSelectedProduto(selected);
        if (un) {
          setSelectedUnidade(un);
        }
      }
      calculaTotal();
    };
  
    const onChangeQtd = (qtd: string) => {
      const quantidade = Number(qtd);
      setQtd(quantidade);
    };
  
  
    const onCalcChangeQtd = (qtd: string) => {
      const quantidade = Number(qtd);
      if (quantidade > 0) {
        calculaTotal();
      } else {
        showError("Erro!", "A quantidade deve ser maior do que 0");
      }
    };
  
    const add = (value: string) => {
      const calc = selectedProduto?.precoVenda * qtd;
      const itemTotal = (calc * Number(value)) / 100 + calc;
  
      const item: OrderItemProduct = {
          novoProdutoId: selectedProduto?.id,
          orcamentoCategoriaId: "",
          quantidade: qtd,
          valorTotal: itemTotal,
          valorUn: selectedProduto?.precoVenda,
          id: "",
          descricao: "",
          NovoProduto: selectedProduto
      };
      addRowItem(item, categ);
      cleanInput();
  
      produtoRef.current.focus();
    };
    const cleanInput = () => {
      setIpi((prev) => (prev = 0));
      setSelectedProduto(null);
      setSelectedUnidade(null);
      setQtd(0);
      setTotal(0);
      produtoRef.current.focus();
    };
  
  
    return (
      <Tr>
        <Td>
          <Box w={300}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              onChange={(e) => {
                onChangeProduto(e.value);
              }}
              ref={produtoRef}
              placeholder="Buscar..."
              isDisabled={false}
              name={"Produto"}
              options={produtos?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
              value={{
                label: selectedProduto?.nome,
                value: selectedProduto?.id,
              }}
            />
          </Box>
        </Td>
        <Td>{selectedProduto?.sku}</Td>
        <Td> {selectedUnidade?.nome}</Td>
        <Td>
          <NumberInput
            precision={2}
            value={qtd}
            style={{
              width: 100,
            }}
            name={`quantidade--`}
            onChange={(e) => {
              onChangeQtd(e);
            }}
            onBlur={(e) => {
              onCalcChangeQtd(e.target.value);
              add('0');
            }}
          >
            <NumberInputField />
          </NumberInput>
        </Td>
        <Td>
          {isNaN(selectedProduto?.precoVenda)
            ? formatNumber(0)
            : formatNumber(Number(selectedProduto?.precoVenda))}
        </Td>
        <Td>{formatNumber(Number(total))}</Td>
        <Td></Td>
      </Tr>
    );
  };
  export default AddItemRow;